export { buildRawColumns, type IRawColumnSpec } from './raw-table-page';

export const DEVEX_METRIC_SPECS: ReadonlyArray<{ key: string; header: string }> = [
  { key: 'productive', header: 'Productive' },
  { key: 'easeOfWork', header: 'Ease of Work' },
  { key: 'satisfiedWithTools', header: 'Satisfied With Tools' },
  { key: 'energy', header: 'Energy' },
  { key: 'bestPractices', header: 'Best Practices' },
  { key: 'focusTime', header: 'Focus Time' },
  { key: 'interrupted', header: 'Interrupted' },
  { key: 'timeWasted', header: 'Time Wasted' },
  { key: 'testCoverage', header: 'Test Coverage' },
  { key: 'shipFrequently', header: 'Ship Frequently' },
  { key: 'easyDeploy', header: 'Easy Deploy' },
  { key: 'ciCd', header: 'CI/CD' },
  { key: 'codeReview', header: 'Code Review' },
  { key: 'codebaseContribution', header: 'Codebase Contribution' },
  { key: 'techDebt', header: 'Tech Debt' },
  { key: 'projectScope', header: 'Project Scope' },
  { key: 'teamProcesses', header: 'Team Processes' },
  { key: 'meetings', header: 'Meetings' },
];

export function buildStandardTblSubtitle(): string {
  return 'Raw table view with field-level filtering.';
}

export function buildStandardEmptyMessage(entityName: string): string {
  return `No ${entityName} rows found.`;
}
